import { render } from "./faq-modal.vue?vue&type=template&id=7c11e9b3"
import script from "./faq-modal.vue?vue&type=script&lang=js"
export * from "./faq-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__